import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/LangContext";

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.05, duration: 0.7, ease: [0.19, 1, 0.22, 1] },
  }),
};

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" className="relative py-28 lg:py-40 bg-[#070708]" data-testid="services-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16 lg:mb-20">
          <div className="lg:col-span-6">
            <div className="text-[11px] uppercase tracking-[0.28em] text-red-400 font-mono-ef">
              — {t.services.overline}
            </div>
            <h2 className="mt-6 font-display font-black text-5xl sm:text-6xl lg:text-8xl leading-[0.9] tracking-[-0.035em]">
              {t.services.title}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 lg:pt-4">
            <p className="text-lg text-white/60 leading-relaxed">{t.services.subtitle}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
          {t.services.items.map((s, i) => (
            <motion.div
              key={s.t}
              custom={i}
              variants={cardVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              className={`card-elev rounded-2xl p-7 lg:p-10 flex flex-col justify-between min-h-[220px] lg:min-h-[280px] col-span-1 ${s.span}`}
              data-testid={`service-${s.t.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-ef text-[10px] uppercase tracking-[0.24em] text-red-400">
                  0{i + 1}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-red-500/70" />
              </div>
              <div>
                <h3 className="font-display text-2xl lg:text-3xl font-bold tracking-tight leading-tight">
                  {s.t}
                </h3>
                <p className="mt-3 text-white/60 text-sm lg:text-base leading-relaxed max-w-md">
                  {s.d}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
